import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { environment } from '@env/environment';
import { ContatoComponent } from '@modules/contato/contato.component';
import { LoginComponent } from '@modules/login/pages/login.component';
import { SobreComponent } from '@modules/sobre/sobre.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { AppSharedDataService } from './app-shared-data.service';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { PerfilEnum } from '@core/models/perfil.models';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GestaoAlertasService } from '@modules/gestao-alertas/components/services/gestao-alertas.service';
import { CustomAlertaComponent } from '@modules/gestao-alertas/components/modal-alerta/custom-alerta.component';
import { ModosExibicaoEnum } from '@modules/gestao-alertas/models/alerta';
import { MonitorService } from '@core/services/monitor.service';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {

  isDeveloper: boolean;
  perfilEnum = PerfilEnum;
  title = 'portal-app';
  isLoggedIn$: Observable<boolean>;
  @ViewChild('principal', { read: ViewContainerRef, static: false }) principal: ViewContainerRef;
  positionScroll: any;
  versao: string;
  menuConfigActive: boolean = false;
  isMenuLoaded: boolean = false;
  showStaticAlert: boolean = false;
  modosExibicaoEnum = ModosExibicaoEnum;
  objAlerta: any;
  staticAlerts: any[];


  constructor(private gtm: GoogleTagManagerService, private authenticationService: AuthenticationService,
    private router: Router, private modalService: NgbModal,
    private appSharedDataService: AppSharedDataService, private localStorageService: LocalStorageService,
    private gestaoAlertasService: GestaoAlertasService,
    private monitorService: MonitorService
  ) {
    console.info(`App Version: ${environment.version}`);
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;

  }

  onMenuToogle(): void {

  }

  ngOnInit(): void {
    this.versao = environment.version;
    this.appSharedDataService.configuracaoMenu$.subscribe((res) => this.menuConfigActive = res)

    const savedDevMode = sessionStorage.getItem('devMode');
    if (savedDevMode === 'true') {
      this.isDeveloper = true;

      if (this.authenticationService.currentUser) {
        this.authenticationService.currentUser['devMode'] = true;
      }
    }

    this.isLoggedIn$.subscribe((res) => {
      if (res && this.authenticationService.currentUser) {
        this.isDeveloper = this.authenticationService.currentUser['devMode'] || sessionStorage.getItem('devMode') === 'true';

        if (sessionStorage.getItem('devMode') === 'true' && !this.authenticationService.currentUser['devMode']) {
          this.authenticationService.currentUser['devMode'] = true;
        }
      } else {
        this.isDeveloper = false;
      }
    })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let url = event.urlAfterRedirects;
        if (url.startsWith('/login')) {
          this.showStaticAlert = false;
          return;
        }
        this.gestaoAlertasService.getAlertaAtivo(url).subscribe(result => {
          this.getAlertas(result)
        })
      }
    })
  }


  getAlertas(alertas) {
    if (alertas?.length) {
      alertas.forEach(alerta => {
        alerta.exhibitionModes.forEach(modo => {
          if (modo == this.modosExibicaoEnum.Modal) {
            if (alerta.triggers?.length) {
              const routeChange$ = this.router.events.pipe(
                filter(e => e instanceof NavigationStart)
              );

              // Ativa monitoramento com os gatilhos do alerta
              this.monitorService.activate(alerta.triggers);

              // Escuta quando um gatilho dispara
              this.monitorService.gatilhoDisparado$.pipe(
                takeUntil(routeChange$)
              )
                .subscribe(gatilho => {
                  this.showModalAlert(alerta);
                });
            } else {
              // Sem gatilhos, mostra imediatamente
              this.showModalAlert(alerta);
            }
          } else if (modo === this.modosExibicaoEnum.Alerta) {
            // estático
            this.showStaticAlert = true;
            this.objAlerta = alerta;
          }
        });
      });
    } else {
      this.showStaticAlert = false;
      this.staticAlerts = [];
      this.monitorService.desactivate(); // Limpa monitoramento se não houver alertas
    }
  }


  ngAfterViewInit(): void {
    this.router.events.subscribe((event) => {
      this.addRecentActivity(event)

      if (event instanceof NavigationEnd) {
        if (event.url.includes('dashboard')) {
          this.gtm.pushTag({
            event: 'page',
            pageName: 'Dashboard'
          });
          this.principal.element.nativeElement.scrollTo(0, this.positionScroll);
        }
      } else {
      }
    })
  }

  openSobre(): void {
    this.modalService.open(SobreComponent, {
      keyboard: false,
      beforeDismiss: () => {
        return this.authenticationService.currentUserValue == null;
      },
      centered: true
    });
  }

  isProduction: boolean = environment.production;

  openContato(): void {
    this.modalService.open(ContatoComponent, {
      keyboard: false,
      beforeDismiss: () => {
        return this.authenticationService.currentUserValue == null;
      },
      centered: true
    });
  }
  onActivate(component: Component) {
    this.isMenuLoaded = !(component instanceof LoginComponent)
  }

  addRecentActivity(event): void {
    // Reseta o menu se não for rota de consulta e/ou dashboard
    if (event instanceof NavigationEnd && !event.url.includes('/dashboard/') && !event.url.includes('/consulta/')) this.appSharedDataService.setResetMenuBootstrap(true);

    if (!event.url || !(event instanceof NavigationStart) || !event.url.includes('/consulta/')) return

    this.gtm.pushTag({
      event: 'page',
      pageName: event.url
    });

    let recentActivity: { historico: { date: Date, url: string }[] } = JSON.parse(this.localStorageService.getItem('atividade-recente')) || null

    const activityContext: { date: Date, url: string } = { date: new Date(), url: event.url }
    const urls = recentActivity ? [...recentActivity.historico.map(e => e.url)] : []

    // Se não possui atividade no histórico
    if (!recentActivity) {
      const rawActivity = {
        historico: [
          activityContext
        ]
      }
      this.localStorageService.setItem('atividade-recente', JSON.stringify(rawActivity));
      // Se possui atividade, porém menor ou igual a 10 e não existe valor igual no array
    } else if (recentActivity.historico.length <= 10 && !urls.includes(activityContext.url)) {
      recentActivity.historico.unshift(activityContext)
      this.localStorageService.setItem('atividade-recente', JSON.stringify(recentActivity));
    }

    // Se possui atividade com mesma url, deve remover a atividade e atribuí-la ao topo da lista
    if (urls.includes(activityContext.url)) {
      const itemIndex = urls.indexOf(activityContext.url)
      recentActivity.historico.splice(itemIndex, 1)
      recentActivity.historico.unshift(activityContext)
      this.localStorageService.setItem('atividade-recente', JSON.stringify(recentActivity));
    }
  }

  showModalAlert(alert) {
    let component = this.modalService.open(CustomAlertaComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true, size: 'xl',
      windowClass: 'custom-alerta',
      backdropClass: 'modal-backdrop-erro',
    });
    let instance = <CustomAlertaComponent>component.componentInstance;
    instance.alerta = { ...alert };
  }

  handleSubmit(event) {
    this.showModalAlert(event);
  }
}